const GET_FUEL_TYPE = 'GET_FUEL_TYPE';
const SET_FUEL_TYPE = 'SET_FUEL_TYPE';

export {
    GET_FUEL_TYPE,
    SET_FUEL_TYPE
};